import React from "react";
import ArticleAddRow from "./articleAddRow";
import { ArticleRow } from "./articleRow";
import * as validator from "../../../../general/validators/validator";
import { Constants } from "../../../../constants";

export const EMPTY_ROW_KEY = -1;

export default class ArticleAddTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newProductName: null,
      pricePredefined: false,
      productOps: [],
      error: this.getDefaultErrors(),
      newVat: Constants.DEFAULT_VAT,
    };
  }

  getDefaultErrors = () => {
    return {
      details: null,
      price: null,
      vat: null,
      quantity: null,
    };
  };

  componentDidMount() {
    let products = this.props.products || [];
    let productOps = products.map((t, i) => {
      return { value: t.id, label: t.name };
    });
    this.setState({
      productOps: productOps,
      yearId: this.props.yearId,
      createdYear: this.props.createdYear,
      orderId: this.props.orderId,
    });
  }

  onAddArticleClicked = () => {
    if (!this.validateInput()) {
      return;
    }

    let productName = "";

    this.state.productOps.forEach((t) => {
      if (t.value === this.state.newProductId) {
        productName = t.label;
      }
    });

    const article = {
      details: this.state.newDetails,
      pricePerUnit: this.state.newPrice,
      quantity: this.state.newQuantity,
      vat: this.state.newVat,
      product: {
        id: this.state.newProductId,
        name: productName,
      },
    };
    let newArticles = this.props.articles.concat([article]);

    this.setState({
      newProductId: null,
      newDetails: "",
      newPrice: "",
      newQuantity: "",
      articolBugetar: "",
      newVat: Constants.DEFAULT_VAT,
      error: this.getDefaultErrors(),
    });
    this.props.onAddArticleClicked(newArticles);
  };

  onDeleteClicked = (index) => {
    this.props.onDeleteClicked(index);
  };

  onProductChanged = (val) => {
    let productPrice = null;
    this.props.products.forEach((t) => {
      if (t.id === val && t.price > 0) {
        productPrice = t.price;
      }
    });

    if (productPrice !== null && productPrice !== undefined) {
      this.setState({
        newProductId: val,
        newPrice: productPrice,
        pricePredefined: true,
      });
    } else {
      this.setState({
        newProductId: val,
        pricePredefined: false,
      });
    }
  };

  onDetailChanged = (e) => {
    this.setState({
      newDetails: e.target.value,
    });
  };

  onPriceChanged = (e) => {
    this.setState({
      newPrice: e.target.value,
    });
  };

  onQuantityChanged = (e) => {
    this.setState({
      newQuantity: e.target.value,
    });
  };

  onArticolBugetarChange = (e) => {
    this.setState({
      articolBugetar: e.target.value,
    });
  };

  onVatChanged = (e) => {
    this.setState({
      newVat: e.target.value,
    });
  };

  validateInput = () => {
    let found = false;
    let error = {};
    let price = this.state.newPrice;
    if (validator.isEmpty(price) || price === 0 || price === "0" || price < 0) {
      found = true;
      error.price = "Lipseste pretul sau este 0";
    }
    let quantity = this.state.newQuantity;
    if (
      validator.isEmpty(quantity) ||
      quantity === 0 ||
      quantity === "0" ||
      quantity < 0
    ) {
      found = true;
      error.quantity = "Lipseste cantitatea sau este 0";
    }
    let vat = this.state.newVat;
    if (validator.isEmpty(vat) || vat < 0) {
      found = true;
      error.vat = "Lipseste TVA-ul sau este negativ";
    }
    if (validator.isEmpty(this.state.newProductId)) {
      found = true;
      error.product = "Lipsa produs";
    }

    this.setState({
      error: error,
    });

    return !found;
  };

  render() {
    let articles = this.props.articles ? this.props.articles : [];

    let articlesRows = articles.map((t, i) => {
      return (
        <ArticleRow
          key={i}
          index={i}
          article={t}
          editable={true}
          articlesSize={999} // set a high value so that always show the delete button for every article
          yearId={this.props.yearId}
          createdYear={this.props.createdYear}
          onEditClicked={this.props.onEditClicked}
          onDetailChanged={this.props.onDetailChanged}
          onVatChanged={this.props.onVatChanged}
          onQuantityChanged={this.props.onQuantityChanged}
          onArticolBugetarChange={this.props.onArticolBugetarChange}
          onPricePerUnitChanged={this.props.onPricePerUnitChanged}
          onDeleteClicked={this.onDeleteClicked}
        />
      );
    });
    return (
      <div>
        <div className="ds-table-card ds-table-card--flat"><table className="table table-hover">
          <tbody>
            <tr>
              <th>Cod articol</th>
              <th>Denumire articol</th>
              <th>Detalii articol</th>
              <th>Pret unitar</th>
              <th>Cota TVA</th>
              <th>Cantitate</th>
              <th>Actiuni</th>
            </tr>
            {articlesRows}
            {
              <ArticleAddRow
                key={EMPTY_ROW_KEY}
                id={EMPTY_ROW_KEY}
                index={articlesRows.length}
                productOps={this.state.productOps}
                newProductId={this.state.newProductId}
                details={this.state.newDetails}
                quantity={this.state.newQuantity}
                price={this.state.newPrice}
                vat={this.state.newVat}
                pricePredefined={this.state.pricePredefined}
                error={this.state.error}
                onQuantityChanged={this.onQuantityChanged}
                onArticolBugetarChange={this.onArticolBugetarChange}
                onPriceChanged={this.onPriceChanged}
                onDetailChanged={this.onDetailChanged}
                onProductChanged={this.onProductChanged}
                onAddArticleClicked={this.onAddArticleClicked}
                onVatChanged={this.onVatChanged}
              />
            }
          </tbody>
        </table></div>
      </div>
    );
  }
}
